/**
 * Полные календарные года от даты начала стажа (ISO yyyy-MM-dd) до сегодня.
 * @returns {number|null}
 */
export function fullYearsSinceMedicalExperienceStart(isoDateString) {
  if (!isoDateString || typeof isoDateString !== "string") return null;
  const parts = isoDateString.trim().split("-");
  if (parts.length < 3) return null;
  const y = parseInt(parts[0], 10);
  const m = parseInt(parts[1], 10) - 1;
  const d = parseInt(parts[2], 10);
  if (Number.isNaN(y) || Number.isNaN(m) || Number.isNaN(d)) return null;
  const start = new Date(y, m, d);
  if (Number.isNaN(start.getTime())) return null;
  const now = new Date();
  let years = now.getFullYear() - start.getFullYear();
  const monthDiff = now.getMonth() - start.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < start.getDate())) {
    years -= 1;
  }
  return Math.max(0, years);
}

/**
 * Склонение для русского «год / года / лет».
 */
export function yearsDeclensionRu(n) {
  const abs = Math.abs(n) % 100;
  const ends = abs % 10;
  if (abs > 10 && abs < 20) return "лет";
  if (ends === 1) return "год";
  if (ends >= 2 && ends <= 4) return "года";
  return "лет";
}
